import { AddendumResponse } from '../../../shared/models/AddendumModel';
import emptySliceApi from '../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    getAddendums: builder.query<
      AddendumResponse[],
      { accountId: string; dealId: string }
    >({
      query: ({ accountId, dealId }) =>
        `v4/accounts/${accountId}/logs/addendum/deal/${dealId}`,
    }),
  }),
});

export const { useGetAddendumsQuery } = apiSlice;
